import { createFileRoute } from '@tanstack/react-router';

import { agreementsSearch, collectionAgreementsScreen, loadCollectionMessages, loadCollectionScreens } from '@/modules/collection/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

export const Route = createFileRoute('/_app/gestao-carteira/recuperacao/acordos/')({
  validateSearch: agreementsSearch,
  staticData: { screen: collectionAgreementsScreen },
  loader: () => loadCollectionMessages(),
  component: lazyScreen(loadCollectionScreens, 'CollectionAgreementsRouteScreen'),
});
